module.exports = __webpack_public_path__ + "media/activity/time-768b6a18.svg";